 
import './Footer.scss';

function Footer() {
  return (
    <footer className="footer">
        <p>&copy; InStock Inc. All Rights Reserved</p>
    </footer>
  );
}

export default Footer;